import { wencesApi } from "@/api/wencesApi";

/**
 * Autocompletado al elegir una referencia (p. ej. el cliente de una proforma): se propone
 * lo cargado en la referencia (la condición de pago del contacto) y, si no tiene, el valor
 * que ese cliente usa habitualmente. Solo completa campos vacíos: nunca pisa lo cargado.
 */
export const REFERENCE_FIELD_SUGGESTIONS = [
  {
    model: /^proform$/i,
    sourceField: "client",
    // `payable` = condición de pago; `advance` = % de adelanto que la acompaña.
    targetFields: ["payable", "advance"],
  },
];

export function findReferenceFieldSuggestion(modelName, fields) {
  const name = String(modelName || "").trim();
  if (!name) return null;
  const rule = REFERENCE_FIELD_SUGGESTIONS.find((r) => r.model.test(name));
  if (!rule) return null;
  if (Array.isArray(fields) && fields.length) {
    const keys = new Set(fields.map((f) => f && f.key).filter(Boolean));
    if (!keys.has(rule.sourceField)) return null;
    const targets = rule.targetFields.filter((t) => keys.has(t));
    if (!targets.length) return null;
    return { ...rule, targetFields: targets };
  }
  return rule;
}

export function isEmptyFormValue(value) {
  if (value === null || value === undefined || value === "") return true;
  if (Array.isArray(value)) return value.length === 0;
  // Una lista vacía del formulario llega como { _id: "", name: "" }.
  if (typeof value === "object") {
    const noId = value._id == null || value._id === "";
    const noValue = value.value == null || value.value === "";
    return noId && noValue;
  }
  return false;
}

export function referenceIdOf(value) {
  if (value === null || value === undefined || value === "") return "";
  if (Array.isArray(value)) return referenceIdOf(value[0]);
  if (typeof value === "object") return value._id != null ? String(value._id) : "";
  return String(value);
}

/**
 * Pide al backend el valor más usado de cada campo para esa referencia.
 * @returns {Promise<Object>} { campo: { value, count, total } }
 */
export async function fetchReferenceFieldSuggestions({
  modelName,
  sourceField,
  sourceValue,
  targetFields,
}) {
  const byValue = referenceIdOf(sourceValue);
  if (!modelName || !sourceField || !byValue || !targetFields?.length) return {};
  const { data } = await wencesApi.get(
    `/api/gotrading/dynamic/${encodeURIComponent(modelName)}/field-suggestion`,
    {
      params: {
        fields: targetFields.join(","),
        byField: sourceField,
        byValue,
      },
    }
  );
  return (data && data.success && data.data) || {};
}
